// rounds/configuration — configuration snapshot provenance
import { z } from "zod";

/**
 * `GET /intake-rounds/{id}/config-snapshot/` metadata.
 *
 * PROVENANCE ONLY — never the source for rendering the configuration. The panel endpoints
 * (`/eligibility/`, `/document-requirements/`, `/form/`) already serve snapshot data themselves once
 * one exists, in exactly the same shape as their live responses, so the read-only view reads them and
 * this adds only "when was it frozen, and against which content hash".
 *
 * `snapshot_data` is deliberately not modelled. It is the full frozen configuration, and parsing a
 * second representation of data we already read through the panels would be two contracts for one
 * truth — the first to drift silently.
 */
export const ConfigSnapshotMetaSchema = z.object({
  id: z.string(),
  snapshot_version: z.number().int(),
  schema_version: z.number().int(),
  content_hash: z.string(),
  created_at: z.string(),
});

export type ConfigSnapshotMeta = z.infer<typeof ConfigSnapshotMetaSchema>;
